import { formatShortDate } from "@common/lib/date-utils"
import { addDays, differenceInCalendarDays, startOfDay } from "date-fns"

export const TODAY = startOfDay(new Date())

export function dateOf(day: number): Date {
  return addDays(TODAY, day)
}

export function dayOf(date: Date): number {
  return differenceInCalendarDays(date, TODAY)
}

export function isWeekend(day: number): boolean {
  const weekday = dateOf(day).getDay()
  return weekday === 0 || weekday === 6
}

export function formatDay(day: number): string {
  return formatShortDate(dateOf(day))
}

export function formatSpan(start: number, end: number): string {
  return `${formatDay(start)} → ${formatDay(end)}`
}

export function formatDays(days: number): string {
  return days === 1 ? "1 day" : `${days} days`
}
